<template>
  <div class="w-full text-center">
    <div class="content">
      <FinalPageModule
        :title="content.title"
        :subTitle="content.subTitle"
        :image="content.image"
        :subText="content.subText"
        :boldText="content.boldText"
        :dotsList="content.dotsList"
        :cardImage="content.cardImage"
        :sidebarTitle="content.sidebarTitle"
        :hideSidebar="content.hideSidebar"
        :sidebarHTML="content.sidebarHTML"
      />
    </div>

    <!-- wait until userSubscribedAnyPlan is evalued -->
    <div v-if="userSubscribedAnyPlan !== null" class="page-footer">
      <!-- if user requested an influencer card but still doesn't have the related plan
          we redirect him to the plan activation page -->
      <button
        v-if="userIsRequestingInfluencerCard && !userSubscribedAnyPlan"
        class="btn"
        @click="goToProfileActivation"
      >
        Ho capito
      </button>
      <button v-else class="btn" @click="backToInitialView">
        Torna alla schermata iniziale
      </button>
    </div>
  </div>
</template>

<script>
import UtilityService from "@/services/UtilityService";
import ApiService from "@/services/ApiService";
import RegistrationService from "@/services/RegistrationService";
import FinalPageModule from "@/modules/FinalPageModule";

export default {
  name: "RegistrationCompleted",
  components: {
    FinalPageModule
  },
  data() {
    return {
      isUpgrade: null,
      userSubscribedAnyPlan: null,
      cardImage: null,
      content: {
        title: "",
        subTitle: "",
        image: null,
        dotsList: [],
        hideSidebar: false,
        boldText: "",
        subText: "",
        cardImage: null,
        sidebarTitle: "",
        sidebarHTML: ""
      }
    };
  },
  computed: {
    appReady() {
      return this.$store.state.appReady;
    },
    userIsRequestingInfluencerCard: function() {
      return (
        !sessionStorage.getItem("cr_upgrade") &&
        this.$store.state.registrations?.prepaidCardResource?.profile &&
        this.$store.state.registrations?.prepaidCardResource?.profile !== "BASE"
      );
    }
  },
  async mounted() {
    if (this.appReady) {
      this.init();
    } else {
      this.$root.$on(`storeUpdated@setAppReady`, state => {
        if (state.appReady) {
          this.init();
        }
      });
    }
  },
  methods: {
    async init() {
      this.isUpgrade = sessionStorage.getItem("cr_upgrade") !== null;
      this.userSubscribedAnyPlan = await RegistrationService.userSubscribedAnyPlan();

      this.$root.$emit("openGlobalLoader");
      try {
        const response = await ApiService.get(`/usr/v2/prepaid-cards/`);
        this.currentCard = response.data?.filter(
          c => c.id === this.$store.state.registrations.prepaidCardResource.id
        )[0];
        this.$root.$emit("closeGlobalLoader");
      } catch (error) {
        this.$root.$emit("closeGlobalLoader");
        UtilityService.showDefaultError(error);
      }

      this.setCardImage();
      this.setContents();
    },
    setCardImage() {
      this.cardImage =
        this.currentCard && this.currentCard.content?.imagesUrl?.front
          ? this.currentCard.content.imagesUrl.front
          : require("@/assets/images/carta-tinaba.png");
    },
    setContents() {
      console.log(this.currentCard);
        this.content.title = "Complimenti!";
        this.content.subTitle = "La richiesta della tua nuova carta è andata a buon fine!";
        this.content.image = require("@/assets/images/conto_ok.png");
        this.content.dotsList = [];
        this.content.hideSidebar = false;
        this.content.boldText = "";
        this.content.subText = "";
        this.content.cardImage = this.cardImage;

         if (this.currentCard.cardType === "VIRTUAL") {
        this.content.sidebarTitle =
          "A breve potrai iniziare a utilizzare la carta!";
        } else {
          this.content.sidebarTitle = "Cosa succede ora​:";
        }

        if (this.currentCard.cardType === "VIRTUAL") {
         this.content.sidebarHTML = `
          La carta Tinaba è una prepagata che opera su circuito Mastercard, accettata in tutto il mondo.<br><br>
          <b>Ricaricala in real time</b> direttamente da App e usala online e nei negozi fisici associandola ai metodi di <b>smart payment</b> che preferisci.`;
        } else {
          this.content.sidebarHTML = `
          <ul style="margin-left: 10px; list-style: initial;">
            <li class="mb-2">Riceverai un'email di conferma non appena avremo spedito la tua carta all'indirizzo che hai indicato.</li>
            <li class="mb-2">Nel frattempo puoi utilizzarla in modalità virtuale: <b>ricaricala in real time</b> direttamente da App e usala per pagare online o nei negozi, associandola ai metodi di <b>smart payment</b> che preferisci.</li>
          </ul>`;
        }

    },
    goToProfileActivation() {
      UtilityService.goToProfileActivation(this.currentCard.id);
    },
    backToInitialView() {
      UtilityService.backToInitialView();
    }
  }
};
</script>
<style lang="less" scoped>
.reg-completed-img {
  width: 150px;
  margin: 20px auto;
}
.info-box {
  text-align: left;
  p {
    margin-bottom: 22px;
  }
  ul {
    margin-left: 20px;
    list-style: initial;
  }
}
.info-card-box {
  margin-top: 65px;
  display: flex;
  height: 100%;
  align-items: center;
  text-align: left;
  .card {
    position: relative;
    .card__box {
      width: 300px;
    }
  }
  img {
    width: 200px;
    position: absolute;
    top: -90px;
    left: 100px;
  }
}
</style>
